import Cookies from 'js-cookie';
import { useLocation } from 'react-router-dom';
import { KioskCookies } from '../../../../helpers/Cookies';
import { useAppointmentState, useAppointmentUpdateAndPersist } from '../../../Appointment/appointment';
import { useSavedSessionDispatch } from '../../SavedSession';
import { SavedSessionCookieData, SavedSessionDispatchTypes } from '../../SavedSession.types';
import type { IAppointment } from '../../../../API/GoMoto';
import type { SavedSessionSaveHook } from './SavedSessionSave.types';

/**
 * Hook exposing `saveSession`, which persists the current appointment as a
 * saved session. Reads the originating route from `location.state.from`,
 * writes the SavedSession cookie with the appointment key and that route,
 * dispatches an update to the SavedSession context, and persists the
 * appointment with `mobileCheckInUrl` set to the originating route. No-ops
 * when `location.state` is not present.
 */
export const useSavedSessionSave: SavedSessionSaveHook = () => {
    const appointment: IAppointment = useAppointmentState();
    const savedSessionDispatch = useSavedSessionDispatch();
    const setAppointment = useAppointmentUpdateAndPersist();
    const location = useLocation();

    return {
        saveSession: async () => {
            if (location.state) {
                const { from } = (location.state as any) || { from: { pathname: '/' } };
                const data: SavedSessionCookieData = {
                    appointmentKey: appointment.key,
                    route: from,
                };
                Cookies.set(KioskCookies.SavedSession, JSON.stringify(data));
                savedSessionDispatch({
                    type: SavedSessionDispatchTypes.Update,
                    payload: data,
                });
                await setAppointment(
                    {
                        ...appointment,
                        mobileCheckInUrl: from,
                    },
                    false,
                    false,
                    false,
                    true,
                    undefined,
                    true,
                    false,
                    true,
                );
            }
        },
    };
};